import React from 'react';

export default function StatCard({ title, value, icon: Icon, onClick, active, variant = 'default' }) {
  const isClickable = !!onClick;
  
  return (
    <button
      onClick={onClick}
      disabled={!isClickable}
      className={`
        relative overflow-hidden rounded-lg border bg-card p-4 text-left transition-all duration-200
        ${isClickable ? 'cursor-pointer hover:shadow-md hover:border-primary/40' : 'cursor-default'}
        ${active ? 'ring-2 ring-primary border-primary shadow-md' : 'border-border'}
      `}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider">{title}</p>
          <p className="text-2xl font-bold mt-1 text-foreground">{value?.toLocaleString?.() ?? value}</p>
        </div>
        {Icon && (
          <div className={`shrink-0 p-2 rounded-lg ${variant === 'health' ? (value > 0 ? 'bg-amber-100 text-amber-600' : 'bg-emerald-100 text-emerald-600') : 'bg-primary/10 text-primary'}`}>
            <Icon className="w-4 h-4" />
          </div>
        )}
      </div>
      {variant === 'health' && (
        <div className="mt-2 flex items-center gap-1.5">
          <div className={`w-1.5 h-1.5 rounded-full ${value > 0 ? 'bg-amber-500' : 'bg-emerald-500'}`} />
          <span className={`text-[11px] font-medium ${value > 0 ? 'text-amber-600' : 'text-emerald-600'}`}>
            {value > 0 ? 'Needs attention' : 'Complete'}
          </span>
        </div>
      )}
    </button>
  );
}